import { checkBrowser } from 'config/browserCheck';
import { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Contract, ethers, formatUnits } from 'ethers';
import { CheckMetaMaskConnectError } from 'config/errorCheck';
import abi from 'config/abi';
import RevealHeaderNav from 'components/Nav/RevealHeaderNav';
import RevealMainPage from './RevealMainPage';
import RevealPage from 'components/reveal/RevealPage';
import Footer from 'components/Footer/Footer';
import RevealLottieModal from 'components/reveal/modal/RevealLottieModal';
import {
  HAVAH_RPC_URL,
  NftContractAddress,
  PolygonContractAddress,
  seasonStatus,
} from 'config/config';
import {
  setAddress,
  setBalance,
  setConnected,
  setKind,
} from 'redux/slice/walletSlice';
import { setAmount } from 'redux/slice/saleSlice';
import IconService, { CallBuilder, HttpProvider } from 'icon-sdk-js';
import axios from 'axios';
import genesisBoxListImg from 'asset/image/genesis_box_list.png';
import { useBodyScrollLock } from 'components/reveal/modal/useBodyScrollLock';

const RevealMain = (props) => {
  const { t } = useTranslation();

  const httpProvider = new HttpProvider(HAVAH_RPC_URL);
  const iconService = new IconService(httpProvider);

  const dispatch = useDispatch();
  const walletConnected = useSelector((state) => state.walletSlice.connected);
  const saleId = useSelector((state) => state.saleSlice.saleId);

  const exMarketSoldOut = {
    Havah: false,
    Pala: false,
    Altava: false,
    Hyper: false,
    Tmon: false,
  };
  const [nftList, setNftList] = useState([]);
  const saleStatus = seasonStatus;
  const [revealLottieModalOpen, setRevealLottieModalOpen] = useState('');

  const { openScroll } = useBodyScrollLock();

  const connectWallet = async (kind) => {
    if (isMobile) {
      window.location.href = '/genesissale/mobile';
      return false;
    } else {
      if (!checkBrowser()) {
        return false;
      }
    }

    if (kind === 'metamask') {
      if (
        exMarketSoldOut['Tmon'] === null ||
        exMarketSoldOut['Tmon'] === undefined
      ) {
        alert(t('ENDSALE_POPUP'));
        return false;
      }

      let signer = null;
      let tempProvider;
      let netId;
      let netName;

      if (window.ethereum === null || window.ethereum === undefined) {
        window.open(
          'https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn',
        );
      } else {
        // Connect to the MetaMask EIP-1193 object. This is a standard
        // protocol that allows Ethers access to make all read-only
        // requests through MetaMask.
        tempProvider = new ethers.BrowserProvider(window.ethereum);

        await tempProvider.getNetwork().then(async (net) => {
          netId = net.chainId.toString();
          netName = net.name;
        });

        // polygon mainNet 137 , matic
        if (netId !== '137' && netName !== 'matic') {
          // 폴리곤 메인넷이 아닐경우
          // 폴리곤 네트워크로 변경
          try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: '0x89' }],
            });
          } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: 'wallet_addEthereumChain',
                  params: [
                    {
                      chainId: '0x89',
                      rpcUrls: ['https://polygon-rpc.com/'],
                      chainName: 'Matic Mainnet',
                      nativeCurrency: {
                        name: 'MATIC',
                        symbol: 'MATIC',
                        decimals: 18,
                      },
                      blockExplorerUrls: ['https://explorer.matic.network'],
                    },
                  ],
                });
              } catch (addError) {
                // handle "add" error
              }
            }
            // handle other "switch" errors
          }
        }

        try {
          await tempProvider.send('eth_requestAccounts', []);
        } catch (e) {
          if (e.error.code !== 4001) {
            alert(t(CheckMetaMaskConnectError(e.error.code)));
          }
        }

        // It also provides an opportunity to request access to write
        // operations, which will be performed by the private key
        // that MetaMask manages for the user.
        signer = await tempProvider.getSigner();
        let tokenAddress;
        let usdtBalance;
        // 메타마스크 지갑 주소
        await signer.getAddress().then(async (result) => {
          tokenAddress = result;

          // Polygonscan
          // Matic address
          // 0x0000000000000000000000000000000000001010
          const a = {
            address: '0x0000000000000000000000000000000000001010',
            abi: [
              'function balanceOf(address a) view returns (uint)',
              'function approve(address a, uint256 b) view returns (bool)',
            ],
          };

          const contract = new Contract(a.address, abi, signer);
          const balance = await contract.balanceOf(tokenAddress);

          usdtBalance = formatUnits(balance, 18);
        });

        // setSigner(signer);

        if (saleId !== '') {
          // alert(t("RETRY_POPUP"));
          // return false;
          if (!saleId.toLowerCase().includes('pub')) {
            await getSaleAddress(saleId, tokenAddress, signer);
          }
          await checkMintable(saleId, tokenAddress, signer);
        }
        dispatch(setAddress(tokenAddress));
        dispatch(setBalance(usdtBalance));
        dispatch(setKind('metamask'));
        dispatch(setConnected(true));
      }
    } else if (kind === 'havah') {
      const revealDateStr = saleStatus.saleScheduleTime.REVEAL_START;
      const revealDate = new Date(revealDateStr);

      const revealTime = revealDate.getTime();
      const curTime = new Date().getTime();

      if (curTime < revealTime) {
        alert(t('NOTREVEAL_POPUP'));
        return false;
      }

      if (!window.havah) {
        //alert('havah is uninstalled!');
        window.open(
          'https://chrome.google.com/webstore/detail/havah-wallet/cnncmdhjacpkmjmkcafchppbnpnhdmon',
        );
      } else {
        let provider = window.havah;

        if (provider !== undefined) {
          provider
            .connect()
            .then(async (result) => {
              dispatch(setAddress(result.body.address));
              dispatch(setBalance('0.0'));
              dispatch(setKind('havah'));
              dispatch(setConnected(true));

              await getNFTList(result.body.address);
            })
            .catch((error) => console.error(`Error: ${error}`));
        }
      }
    }
  };

  const getSaleAddress = async (sale, address, signer) => {
    //console.log("getSaleAddress start :", sale, address, signer);
    if (sale !== '' && address !== '' && signer !== undefined) {
      const testContract = new Contract(PolygonContractAddress, abi, signer);
      const getSaleAddressFunc = testContract.getFunction('getSaleAddress');
      await getSaleAddressFunc(sale, address)
        .then((res) => {
          //
        })
        .catch((e) => {
          console.log(e);
          alert(t('NONOGNWL_POPUP'));
        });
    }
  };
  const checkMintable = async (sale, address, signer) => {
    //console.log("checkMintable start :", sale, address, signer);
    if (sale !== '' && address !== '' && signer !== undefined) {
      const testContract = new Contract(PolygonContractAddress, abi, signer);
      const mintAbleFunc = testContract.getFunction('mintable');
      let purchases;
      await mintAbleFunc(sale, address)
        .then((res) => {
          purchases = res.toString();
        })
        .catch((e) => {
          //alert(t('NONOGNWL_POPUP'));
        });

      //console.log("checkMintable end 구매가능갯수 :", purchases);
      dispatch(setAmount(purchases));
    }
  };

  const getNFTList = async (val) => {
    // 지갑 검증 api 사용해야되는 부분

    const balanceCall = new CallBuilder()
      .to(NftContractAddress)
      .method('balanceOf')
      .params({ _owner: val })
      .build();

    const res = await iconService.call(balanceCall).execute();

    const nftCount = Number(res);

    if (nftCount >= 1) {
      const nfts = [];
      for (let i = 0; i < res; i += 1) {
        if (Number(i) < 0 || Number(i) >= nftCount) {
          throw new Error('Invalid index');
        }

        const getNftId = new CallBuilder()
          .to(NftContractAddress)
          .method('tokenOfOwnerByIndex')
          .params({
            _owner: val,
            _index: '' + i,
          })
          .build();
        const nftId = await iconService.call(getNftId).execute();

        const getNftURI = new CallBuilder()
          .to(NftContractAddress)
          .method('tokenURI')
          .params({ _tokenId: nftId })
          .build();

        const nftURI = await iconService.call(getNftURI).execute();

        const nftMetadata = await getNftUseURI(nftURI);

        if (nftMetadata !== false) {
          const nft = nftMetadata.data;
          //console.log(nft);
          nft.isApproved = await checkNftAprroved(nftId);

          const nftAttributes = nft.attributes;

          nft.id = Number(nftId);
          nft.tokenId = nftId;
          let revealed = false;
          for (const nftAttributesKey in nftAttributes) {
            const trait_type = nftAttributes[nftAttributesKey]['trait_type'];
            const value = nftAttributes[nftAttributesKey]['value'];

            // 리빌 된 상태에서는 Vehicle Grade 로 읽어야됨.
            if (trait_type === 'Vehicle Grade') {
              nft.rarity = value;
              revealed = true;
            }

            if (trait_type === 'Vehicle Type') {
              nft.kind = value;
            }
          }
          if (!revealed) {
            nft.image = genesisBoxListImg;
          }
          nft.isRevealed = revealed;
          nfts.push(nft);
        }
      }

      setNftList(nfts);
    }
  };

  const getNftUseURI = async (uri) => {
    let result;
    await axios
      .get(uri)
      .then((r) => {
        result = r;
        //console.log(r);
      })
      .catch((error) => {
        console.log(error);
        result = false;
      });
    return result;
  };

  const checkNftAprroved = async (tokenId) => {
    const nftIsRevealed = new CallBuilder()
      .to(NftContractAddress)
      .method('isRevealed')
      .params({ _tokenId: tokenId })
      .build();

    const isRevealed = await iconService.call(nftIsRevealed).execute();

    return isRevealed === '0x1';
  };

  const nftReveal = async (id) => {
    alert(t('NONREVEALABLE_POPUP'));
    return false;
  };

  const handleRevealLottieClose = () => {
    openScroll();
    setRevealLottieModalOpen('');
  };

  if (walletConnected && nftList.length > 0) {
    return (
      <div className="App">
        <RevealHeaderNav walletConnectFunc={connectWallet} />
        <RevealMainPage walletConnectFunc={connectWallet} />
        <RevealPage
          nftList={nftList}
          funcReveal={nftReveal}
        />
        <Footer />
        <RevealLottieModal
          open={revealLottieModalOpen}
          handleClose={handleRevealLottieClose}
        />
      </div>
    );
  }

  return (
    <div className="App">
      <RevealHeaderNav walletConnectFunc={connectWallet} />
      <RevealMainPage walletConnectFunc={connectWallet} />
      <RevealPage
        nftList={nftList}
        funcReveal={nftReveal}
      />
      <Footer />
    </div>
  );
};

export default RevealMain;
